import React from 'react';
import Translate from '../../Translate/Translate';

const TimeSliders = props => {
    const [inputClicked, setInputClicked] = React.useState(false);

    return (
        <div className="time-sliders">
            <form onSubmit={e => e.preventDefault()}>
                <input
                    maxLength={2}
                    name="time-interval-input"
                    type={inputClicked ? 'number' : 'text'}
                    min={0}
                    value={props.currentInterval[props.timeSpan[0]]}
                    placeholder="0"
                    className={
                        inputClicked
                            ? 'time-sliders__input--open'
                            : 'time-sliders__input'
                    }
                    onFocus={() => setInputClicked(true)}
                    onBlur={() => setInputClicked(false)}
                    onKeyDown={e => {
                        if (e.key === '-' || e.key === '.') e.preventDefault();
                    }}
                    onChange={e => {
                        props.onIntervalChangeHandler(
                            e.target.value,
                            props.timeSpan
                        );
                    }}
                />
                <label
                    htmlFor="time-interval-input"
                    className={
                        props.currentInterval[props.timeSpan[0]] !== 0
                            ? 'has-value'
                            : ''
                    }
                >
                    <Translate message={props.timeSpan} />
                </label>
            </form>
        </div>
    );
};

export default TimeSliders;
